function moduleMenus(){
	//v2
	$('.js__menu-trigger').on('click', function(e) {
		e.preventDefault();
		var target = $(this).data('menu');

		$('.js__menu-trigger').removeClass('active');
		$(this).addClass('active');

		$('.menu').removeClass('active');
		$('#menu-'+target).addClass('active');		

		$('html, body').animate({
        	scrollTop: $('.m__menus-module .menus-display').offset().top - $('header').outerHeight()
        }, 800);
	});

	// Menu filter functionality
	$('.menu-filter-btn').on('click', function(e) {
		e.preventDefault();
		
		// Remove active class from all buttons
		$('.menu-filter-btn').removeClass('active');
		
		// Add active class to clicked button
		$(this).addClass('active');
		
		const category = $(this).data('category');
		
		// Filter menu items based on category
		$('.m__link-images .il-item').each(function() {
			const menuCategory = $(this).data('category');
			if (menuCategory === category) {
				$(this).fadeIn();
			} else {
				$(this).hide();
			}
		});
	});

	// Trigger Philadelphia filter on page load
	$('.menu-filter-btn[data-category="philadelphia"]').trigger('click');

	//v1
	$('.menus-nav li').click(function(){
		var target = $(this).data('menu');

		$('.menus-nav li').removeClass('active');
		$(this).addClass('active');

		$('.menu').removeClass('active');
		$('#menu-'+target).addClass('active');
	});
}